import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from "../../Components/Footer";
import ScrollToTop from "../../Components/scrollpageUp";
import "./style.css";

export default function Home() {
  const settings = {
    focusOnSelect: true,
    pauseOnHover: false,
    infinite: true,
    speed: 1100,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: false,
    arrows: false,
    dots: true,
  };

  
  return (
    <div className="home">
      <ScrollToTop />
      <div className="carouselHome">
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <div key={index} className="slide-item">
              <img
                src={require(`../../images/${slide.img}.jpg`)}
                alt={`Slide ${index + 1}`}
              />
              <div
                className="slideText"
                style={{
                  backgroundImage: `url(${require(`../../images/${slide.img}.jpg`)})`,
                }}
              >
                <div>
                  <p>{slide.descreption}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <div className="homeMenu">
        {produits.map((slide, index) => (
          <div className="homeMenuDetails">
            <img
              src={require(`../../images/${slide.img}.jpg`)}
              alt={`Slide ${index + 1}`}
            />
             <div className="homeMenuDetail">
            <h3>{slide.nom}</h3>
            <p>{slide.descreption}</p>
                   <a href="https://glovoapp.com/tn/en/sfax/la-mascotte-sfx/" target="_blank" rel="noreferrer"> order online</a>
             
                </div>
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
}
const slides = [
  {
    img: "ban1",
    descreption:
      "Des saveurs qui racontent une histoire",
  },
  {
    img: "ban2",
    descreption:
      "Partagez des moments gourmands en famille ou entre amis",
  },
  {
    img: "ban3",
    descreption:
      "Goûtez à l'excellence à chaque plat",
  },
  {
    img: "ban4",
    descreption:
      "Explorez notre carte et savourez nos plats",
  },
];
  const produits = [
    {
      img: "produit1",
      nom: "Le Family Box",
      descreption:
        "le choix idéal pour partager un déjeuner en famille",
    },
    {
      img: "produit2",
      nom: "Plat Gourmand",
      descreption:
        "Plats variés et gourmands, préparés avec des ingrédients frais pour satisfaire toutes vos envies",
    },
    {
      img: "produit3",
      nom: "Super Bol Healthy",
      descreption:
        "Bols nutritifs et équilibrés, combinant des protéines et des légumes pour un repas sain et délicieux",
    },
  ];